import request from '@/utils/request'

// 获取首页轮播图
export function fetchList() {
  return request({
    url: 'app/contactAddress/queryList',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/contactAddress.js